/**
 * Opening Range Breakout (ORB)
 *
 * Plots the high and low of the opening range (first N minutes)
 * as horizontal reference lines for breakout strategies.
 *
 * Category: Sessions | Pane: Overlay
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const orbIndicator: IndicatorDefinition = {
  id: "opening_range_breakout",
  name: "Opening Range Breakout",
  shortName: "ORB",
  category: "sessions",
  pane: "overlay",
  params: [
    { key: "minutes", label: "Minutes", type: "number", default: 15, min: 5, max: 120, step: 5 },
    { key: "sessionStart", label: "Session Start (UTC Hr)", type: "number", default: 9, min: 0, max: 23 },
  ],
  plots: [
    { key: "orbHigh", label: "ORB High", color: "#F44336", style: "line", lineWidth: 2 },
    { key: "orbLow", label: "ORB Low", color: "#4CAF50", style: "line", lineWidth: 2 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { minutes, sessionStart } = params;
    const highData: { time: number; value: number }[] = [];
    const lowData: { time: number; value: number }[] = [];

    let orbHigh = -Infinity;
    let orbLow = Infinity;
    let orbSet = false;
    let currentDay = -1;

    for (let i = 0; i < candles.length; i++) {
      const date = new Date(candles[i].time * 1000);
      const day = date.getUTCDate();
      const hour = date.getUTCHours();
      const minute = date.getUTCMinutes();

      if (day !== currentDay) {
        currentDay = day;
        orbHigh = -Infinity;
        orbLow = Infinity;
        orbSet = false;
      }

      const minutesSinceOpen = (hour - sessionStart) * 60 + minute;
      if (minutesSinceOpen >= 0 && minutesSinceOpen < minutes) {
        if (candles[i].high > orbHigh) orbHigh = candles[i].high;
        if (candles[i].low < orbLow) orbLow = candles[i].low;
        orbSet = true;
      }

      if (orbSet && orbHigh > -Infinity) {
        highData.push({ time: candles[i].time, value: orbHigh });
        lowData.push({ time: candles[i].time, value: orbLow });
      }
    }

    return [
      { key: "orbHigh", data: highData },
      { key: "orbLow", data: lowData },
    ];
  },
};
